<template>
  <div class="oai-StepActions">
    <AppButtonNext
      :disabled="isNextDisabled"
      :loading="loading"
      :size="BUTTON_SIZES_NEXT.XL"
      class="oai-StepActions_Next"
      :icon-after="iconAfter"
      @click="$emit('next')"
    >
      <slot>
        {{ $t('action.next') }}
      </slot>
    </AppButtonNext>
  </div>
</template>

<script setup>
import { computed } from 'vue'

import { useOnboardingAiStepContext } from '@/composables/onboarding-ai-step'
import { BUTTON_SIZES_NEXT } from '@/utils/components-configurations/app-button'

import AppButtonNext from '@/components/ui/AppButtonNext/AppButtonNext'

defineOptions({
  name: 'OnboardingAiStepActions'
})

const props = defineProps({
  disable: {
    type: Boolean
  },

  loading: {
    type: Boolean
  },

  iconAfter: {
    type: String,
    default: ''
  }
})

const stepContext = useOnboardingAiStepContext()

const isNextDisabled = computed(() => props.disable || Boolean(stepContext?.navigating))

defineEmits({
  next: null
})
</script>

<style lang="scss" scoped>
.oai-StepActions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
}
</style>
